import React, { createContext, useState, useEffect } from "react";

export const KanchiOMAuthContext = createContext();

export const KanchiOMAuthProvider = ({ children }) => {

  const [token, setToken] = useState(
    localStorage.getItem("kanchiOMToken") || null
  );

  const [manager, setManager] = useState(null);

  // ==========================================
  // Decode JWT helper
  // ==========================================
  const decodeToken = (jwtToken) => {
    try {
      return JSON.parse(atob(jwtToken.split(".")[1]));
    } catch {
      return null;
    }
  };

  // ==========================================
  // LOGIN
  // ==========================================
  const login = async (email, password) => {

    const response = await fetch(
      "https://fliplyn-b-c.fly.dev/cafe-owner/login",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, password })
      }
    );

    if (!response.ok) {
      throw new Error("Invalid Credentials");
    }

    const data = await response.json();

    // Save token separately
    localStorage.setItem("kanchiOMToken", data.access_token);
    setToken(data.access_token);

    const decoded = decodeToken(data.access_token);
    setManager(decoded);

    return true; // let component decide navigation
  };

  // ==========================================
  // LOGOUT
  // ==========================================
  const logout = () => {
    localStorage.removeItem("kanchiOMToken");
    setToken(null);
    setManager(null);
  };

  // ==========================================
  // Restore manager on refresh
  // ==========================================
  useEffect(() => {
    if (token) {
      const decoded = decodeToken(token);
      setManager(decoded);
    }
  }, [token]);

  return (
    <KanchiOMAuthContext.Provider
      value={{
        token,
        manager,
        login,
        logout,
        isAuthenticated: !!token
      }}
    >
      {children}
    </KanchiOMAuthContext.Provider>
  );
};